var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ErrorCodes, useErrorState } from '../stores/errorStateStore';
import { useCallback } from 'react';
import { useForceCloseCaseRequest } from '../api/useForceCloseCaseRequest';
export const useForceCloseConversation = () => {
    const forceCloseCaseRequest = useForceCloseCaseRequest();
    const { setErrorState } = useErrorState();
    return useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const result = yield forceCloseCaseRequest({});
            return result.forceCloseCase;
        }
        catch (e) {
            setErrorState({ code: ErrorCodes.UNKNOWN, originalError: e });
            throw e;
        }
    }), [forceCloseCaseRequest, setErrorState]);
};
